export default __webpack_public_path__ + "static/media/phishing-indentify4.8e6bdd4f.png";